// @core/api/endpoints/workflow/delete_prompt_template.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/workflow';

/**
 * Delete prompt template
 * Deletes a prompt template. Builtin templates cannot be deleted. Pipelines whose nodes reference the template fail at run time with an error naming it.
 */
export async function DeletePromptTemplate(
  template_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/prompt-templates/:template_id`;
  requestPath = requestPath.replace(':template_id', encodeURIComponent(template_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
